export const routes={
    home : '/',
    about : '/about', 
    shop : '/shop', 
    login: '/login',
    signup: '/signup',
    resetPassword: '/resetPassword',
    userProfile: '/userProfile',
    discordCallback: '/auth/discord/callback'
}